require('./product.less');
import Events from '../tracker/events';
const event = new Events();
event.onShowProductCard();

$('#toogle_open').click(function(){
    $('.li_toogle').css('display','list-item');
    $('.li_toogle').addClass('li_toogle_close');
    $('#toogle_open').css('display','none');
    $('#toogle_close').css('display','block');
});
$('#toogle_close').click(function(){
    $('.li_toogle').css('display','none');
    $('.li_toogle').removeClass('li_toogle_close');
    $('#toogle_open').css('display','block');
    $('#toogle_close').css('display','none');
})


// WEBPACK FOOTER //
// ./blocks/product/product.js